export const channelColorThemeIds = ['sky', 'sage', 'lavender', 'amber', 'rose', 'teal', 'mist'] as const

export type ChannelColorThemeId = typeof channelColorThemeIds[number]

export type ChannelColorTheme = {
  id: ChannelColorThemeId
  label: string
  accent: string
  accentHover: string
  accentGlow: string
  ambientGlow: string
  ambientGlowAlt: string
  cardTint: string
}

export const defaultChannelColorThemeId: ChannelColorThemeId = 'sky'

export const channelColorThemes: ChannelColorTheme[] = [
  {
    id: 'sky',
    label: 'Sky',
    accent: '#7aa0be',
    accentHover: '#8fb0ca',
    accentGlow: 'rgba(122, 160, 190, 0.28)',
    ambientGlow: 'rgba(118, 164, 181, 0.34)',
    ambientGlowAlt: 'rgba(232, 200, 138, 0.28)',
    cardTint: 'rgba(118, 164, 181, 0.2)'
  },
  {
    id: 'sage',
    label: 'Sage',
    accent: '#82a980',
    accentHover: '#94b691',
    accentGlow: 'rgba(130, 169, 128, 0.26)',
    ambientGlow: 'rgba(130, 178, 150, 0.32)',
    ambientGlowAlt: 'rgba(217, 192, 125, 0.24)',
    cardTint: 'rgba(130, 178, 150, 0.19)'
  },
  {
    id: 'lavender',
    label: 'Lavender',
    accent: '#9a88c4',
    accentHover: '#aa9acf',
    accentGlow: 'rgba(154, 136, 196, 0.26)',
    ambientGlow: 'rgba(154, 136, 196, 0.3)',
    ambientGlowAlt: 'rgba(235, 182, 158, 0.26)',
    cardTint: 'rgba(154, 136, 196, 0.19)'
  },
  {
    id: 'amber',
    label: 'Amber',
    accent: '#c9a84c',
    accentHover: '#d9b85c',
    accentGlow: 'rgba(201, 168, 76, 0.25)',
    ambientGlow: 'rgba(232, 200, 138, 0.3)',
    ambientGlowAlt: 'rgba(127, 176, 188, 0.22)',
    cardTint: 'rgba(232, 200, 138, 0.2)'
  },
  {
    id: 'rose',
    label: 'Rose',
    accent: '#c48e80',
    accentHover: '#d09d90',
    accentGlow: 'rgba(196, 142, 128, 0.25)',
    ambientGlow: 'rgba(196, 142, 128, 0.28)',
    ambientGlowAlt: 'rgba(127, 176, 188, 0.25)',
    cardTint: 'rgba(196, 142, 128, 0.18)'
  },
  {
    id: 'teal',
    label: 'Teal',
    accent: '#75aaa9',
    accentHover: '#88bab9',
    accentGlow: 'rgba(117, 170, 169, 0.25)',
    ambientGlow: 'rgba(117, 170, 169, 0.3)',
    ambientGlowAlt: 'rgba(177, 202, 145, 0.24)',
    cardTint: 'rgba(117, 170, 169, 0.18)'
  },
  {
    id: 'mist',
    label: 'Mist',
    accent: '#8a9aa3',
    accentHover: '#9ba9b0',
    accentGlow: 'rgba(138, 154, 163, 0.24)',
    ambientGlow: 'rgba(116, 153, 199, 0.31)',
    ambientGlowAlt: 'rgba(177, 202, 145, 0.24)',
    cardTint: 'rgba(116, 153, 199, 0.18)'
  }
]

export const getChannelColorTheme = (
  colorTheme: ChannelColorThemeId | string | null | undefined
): ChannelColorTheme =>
  channelColorThemes.find((theme) => theme.id === colorTheme)
  ?? channelColorThemes.find((theme) => theme.id === defaultChannelColorThemeId)!
